import datadogActions, { DATADOG_EVENT } from './index';

let trackedSessionUserId: string | number | undefined;

export const trackUserSession = (userId: string | number) => {
  if (trackedSessionUserId === userId) {
    return;
  }

  trackedSessionUserId = userId;
  datadogActions.trackDatadogAction(DATADOG_EVENT.userSessionStarted, {
    userId: String(userId),
  });
};

export const trackUrlSessionView = (pathname: string) => {
  datadogActions.trackDatadogAction(DATADOG_EVENT.urlSessionView, {
    path: pathname,
  });
};
